import { render, staticRenderFns } from "./Globals.vue?vue&type=template&id=04ba9b0e"
import script from "./Globals.vue?vue&type=script&lang=js"
export * from "./Globals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports